import { AnimatePresence, motion } from 'motion/react';
import { NewRecord } from './NewRecord/NewRecord';
import { NoizeGraf } from './NoizeGraf/NoizeGraf';

import styles from './NoizeMeter.module.css';

export const NoizeMeter = ({ noiseLevel, maxNoiseLevel, isNewRecord }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className={styles.noizeMeter}
    >
      <AnimatePresence>
        <motion.div
          animate={{ opacity: isNewRecord ? 0 : 1 }}
          transition={{ duration: 1, delay: isNewRecord ? 1 : 0 }}
          className={styles.noizeGrafWrapper}
        >
          <NoizeGraf
            noiseLevel={noiseLevel}
            maxNoiseLevel={maxNoiseLevel}
            variant="leftGap"
          />
          <NoizeGraf noiseLevel={noiseLevel} maxNoiseLevel={maxNoiseLevel} />
          <NoizeGraf
            noiseLevel={noiseLevel}
            maxNoiseLevel={maxNoiseLevel}
            variant="leftGap"
          />
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        {isNewRecord && (
          <motion.div
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: [0.6, 1, 0.6, 1, 0.6, 1] }}
            transition={{
              scale: { duration: 2.5 },
              opacity: { duration: 0.5 },
            }}
            exit={{ opacity: 0 }}
            className={styles.newRecordBlock}
          >
            <NewRecord noiseLevel={noiseLevel} />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};
